import React, { useState, useEffect } from 'react';
import { AlertCircle, X, Users } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import bookingService from '../services/bookingService';
import authService from '../services/authService';
import './ParticipantsNotification.css';

export default function ParticipantsNotification() {
  const [showNotification, setShowNotification] = useState(false);
  const [partiesWithoutParticipants, setPartiesWithoutParticipants] = useState([]);
  const [dismissed, setDismissed] = useState(false);
  const [isChecking, setIsChecking] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // ⚡ OTIMIZAÇÃO: Só verificar em páginas específicas
    const pagesToCheck = ['/meus-agendamentos', '/admin/dashboard'];
    const shouldCheck = pagesToCheck.includes(location.pathname);
    
    if (shouldCheck) {
      checkMissingParticipants();
    }
  }, [location.pathname]);

  const checkMissingParticipants = async () => {
    if (isChecking) return;
    
    try {
      setIsChecking(true);
      
      const isLoggedIn = authService.isAuthenticated();
      
      if (!isLoggedIn) {
        return;
      }

      const response = await bookingService.checkMissingParticipants();
      
      if (response && response.hasMissingParticipants && response.parties && response.parties.length > 0) {
        setPartiesWithoutParticipants(response.parties);
        setShowNotification(true);
      } else {
        setShowNotification(false);
      }
    } catch (error) {
      console.error('Erro ao verificar participantes:', error);
    } finally {
      setIsChecking(false);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    setShowNotification(false);
  };

  const handleNavigateToBookings = () => {
    navigate('/meus-agendamentos');
    setShowNotification(false);
  };

  if (!showNotification || dismissed) {
    return null;
  }

  return (
    <div className="participants-notification">
      <div className="notification-content">
        <div className="notification-icon">
          <AlertCircle size={24} />
        </div>
        <div className="notification-text">
          <h4>Lista de Participantes Pendente</h4>
          <p>
            {partiesWithoutParticipants.length === 1 
              ? 'Você tem 1 festa de aniversário sem a lista de participantes preenchida.'
              : `Você tem ${partiesWithoutParticipants.length} festas de aniversário sem a lista de participantes preenchida.`
            }
          </p>
          <button 
            className="notification-action-button"
            onClick={handleNavigateToBookings}
          >
            <Users size={16} />
            Preencher Lista
          </button>
        </div>
        <button 
          className="notification-close"
          onClick={handleDismiss}
          aria-label="Fechar notificação"
        >
          <X size={20} />
        </button>
      </div>
    </div>
  );
}